import { parseSpiceModelSection, parseSpiceModelSelector } from "../../LibraryHelper/SpiceModelHelper";

class GenericSpiceModelHelper {
  constructor(ids = []) {
    for (const id of ids) {
      this[id] = null;
    }
  }

  getSpiceFiles() {
    return Object.keys(this);
  }

  parseModelSukckts = (id, fileContent) => {
    this[id].subckts = parseSpiceModelSelector(fileContent);
  }

  parseModelSection = (id, fileContent) => {
    const { models, subckts } = parseSpiceModelSection(fileContent);
    this[id].subckts = subckts;
    this[id].models = models
  }

  parseModel = (id, fileContent) => {
    this[id] = {};
    this.parseModelSukckts(id, fileContent);
    this.parseModelSection(id, fileContent);
  }

  /*get model by id*/
  getModelList = (id) => {
    return this[id];
  }

  getModels(id) {
    if (!this[id]) {
      return null
    }
    return this[id].models
  }

  getModelSubckts(id) {
    if (!this[id]) {
      return null
    }
    return this[id].subckts
  }

  deleteModel(id) {
    delete this[id]
  }
}

export default GenericSpiceModelHelper;